<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Forgot your password?</h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Enter your email address and we will send you a link to reset your password.
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
        <div v-if="message" class="bg-green-50 p-4 rounded-md">
          <p class="text-sm text-green-700">{{ message }}</p>
        </div>
        <form v-else @submit.prevent="requestReset" class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">Email address</label>
            <div class="mt-1">
              <input v-model="email" id="email" type="email" autocomplete="email" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500">
            </div>
          </div>
          <div>
            <button type="submit" class="w-full flex justify-center py-2 px-4 border rounded-md text-white bg-blue-600 hover:bg-blue-700" :disabled="isLoading">
              <span v-if="isLoading">Sending...</span>
              <span v-else>Send Password Reset Email</span>
            </button>
          </div>
        </form>
        <div class="mt-4 text-center text-sm">
          <router-link to="/login" class="text-blue-500 hover:text-blue-700">Back to Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from '../services/axiosInstance'

const email = ref('')
const isLoading = ref(false)
const message = ref('')

const requestReset = async () => {
  isLoading.value = true
  message.value = ''
  try {
    const response = await axios.post('/forgot-password', { email: email.value })
    message.value = response.data
  } catch (error) {
    // For security, show the same message even on error.
    message.value = 'If an account with this email exists, a password reset link has been sent.'
  } finally {
    isLoading.value = false
  }
}
</script>
